import React from "react";
import { CodeBlock } from "react-code-block";
import { useCopyToClipboard } from "react-use";
import "@fortawesome/fontawesome-svg-core/styles.css";
import YouTube from "react-youtube";

function LegoL99EDataComponent({ code, language }) {
  code = `// Data-driven L99E: renders the l099E 3-up resource grid from an array,
// so a section is a short data file instead of ~110 lines of JSX.
// Component: components/legosRefactored-24/dataDriven/LegoL99EData.js
// URL helpers: dataDriven/assets.js (pdf2026 / thumb2026 encode spaces, &, etc.)

import LegoL99EData from "../legosRefactored-24/dataDriven/LegoL99EData";
import { pdf2026, thumb2026 } from "../legosRefactored-24/dataDriven/assets";

// one manifest per section — one row per card
const cards = [
  {
    title: "Green Light Foods",
    pdf: pdf2026("Managing Diabetes", "Green Light Foods.pdf"),
    thumb: thumb2026("Green Light Foods.jpg"),
  },
  // ...more cards
];

// render the whole section's grid:
<LegoL99EData cards={cards} />`;
  language = "jsx";
  const [state, copyToClipboard] = useCopyToClipboard();

  const copyCode = () => {
    copyToClipboard(code);
  };

  return (
    <CodeBlock code={code} language={language}>
      <div className="relative">
        <CodeBlock.Code className="bg-black">
          <div className="table-row">
            <CodeBlock.LineNumber className="table-cell pr-4 text-sm text-gray-500 text-right select-none" />
            <CodeBlock.LineContent className="table-cell">
              <CodeBlock.Token />
            </CodeBlock.LineContent>
          </div>
        </CodeBlock.Code>
        <div className="buttonContainer">
          <button className="btn btn-primary ml-auto" onClick={copyCode}>
            <i className="fa-solid fa-copy"></i>{" "}
            {state.value ? "Copied!" : "Copy code"}
          </button>
        </div>
      </div>
    </CodeBlock>
  );
}

export default LegoL99EDataComponent;
